import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-[#07113a] border-t border-[#344271] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-16 mb-20">
          <div className="col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-8 group">
              <div className="w-10 h-10 flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
                <img 
                  src="https://i.imgur.com/xLoRiqR.png" 
                  alt="Crucible Lab" 
                  className="w-full h-full object-contain"
                  referrerPolicy="no-referrer"
                />
              </div>
              <span className="text-xl font-bold tracking-tighter text-white uppercase font-montserrat">Crucible Lab</span>
            </Link>
            <p className="text-[#94a3b8] max-w-sm leading-relaxed text-lg font-medium">
              Custom websites and apps for growing businesses. Built in Rapid City by the creator of more than a dozen digital products.
            </p>
          </div>

          <div>
            <h4 className="text-white font-black uppercase tracking-[0.2em] text-xs mb-8">Studio</h4>
            <ul className="space-y-4 text-[#94a3b8] text-sm font-bold uppercase tracking-widest">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/portfolio" className="hover:text-white transition-colors">Portfolio</Link></li>
              <li><Link to="/how-we-build" className="hover:text-white transition-colors">How We Build</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-black uppercase tracking-[0.2em] text-xs mb-8">Location</h4>
            <p className="text-[#94a3b8] text-sm leading-relaxed font-bold uppercase tracking-widest">
              Rapid City, South Dakota<br />
              Direct access for every client.
            </p>
          </div>
        </div>

        <div className="pt-12 border-t border-[#344271] flex flex-col md:flex-row justify-between items-center text-[#64748b] text-[10px] font-black uppercase tracking-[0.3em]">
          <p>© {new Date().getFullYear()} Crucible Lab LLC. All rights reserved.</p>
          <p className="mt-4 md:mt-0 italic">A studio inside 102:18 INC.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;